const appConfigJson = require('../../config')


class AppConfig {

    config = null;

    constructor(config) {

        this.config = config;
    }

    get() {
        return this.config;
    }
}

export default new AppConfig(appConfigJson);

